

const initialState = {
  editingDomain: {},
};

const editDomain = (state = initialState, action) => {
  switch (action.type) {
    case "EDIT_DOMAIN":
      return {
        ...state,
        editingDomain: action.data,
      };

    default:
      return state;
  }
};
export default editDomain